/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ServiceJourneyStep,
    ServiceJourneyStepFromJSON,
    ServiceJourneyStepToJSON,
} from './';

/**
 *
 * @export
 * @interface ServiceJourney
 */
export interface ServiceJourney {
    /**
     *
     * @type {string}
     * @memberof ServiceJourney
     */
    title: string;
    /**
     *
     * @type {Array<ServiceJourneyStep>}
     * @memberof ServiceJourney
     */
    serviceJourneySteps: ServiceJourneyStep[];
}

export function ServiceJourneyFromJSON(json: any): ServiceJourney {
    return ServiceJourneyFromJSONTyped(json, false);
}

export function ServiceJourneyFromJSONTyped(json: any, _: boolean): ServiceJourney {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': json['title'],
        'serviceJourneySteps': ((json['service_journey_steps'] as any[]).map(ServiceJourneyStepFromJSON)),
    };
}

export function ServiceJourneyToJSON(value?: ServiceJourney | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'service_journey_steps': ((value.serviceJourneySteps as any[]).map(ServiceJourneyStepToJSON)),
    };
}
